import { Prismic, PrismicText, isEmptyText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { TextWithSideText } from '../components/slices/TextWithSideText';

interface IProps {
  copy: Prismic.RichText;
  side_title: Prismic.RichText;
  side_text?: Prismic.RichText;
  template: string;
}

export const TextWithSideTextContainer = ({
  copy,
  side_title,
  side_text,
  template,
}: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }

  const isArticle = template === 'article';

  return (
    <Segment isArticle={isArticle}>
      <TextWithSideText
        isArticle={isArticle}
        sideText={<PrismicText value={side_text} />}
        title={Prismic.text(side_title)}
      >
        <PrismicText value={copy} isArticle={isArticle} />
      </TextWithSideText>
    </Segment>
  );
};
